module.exports = __webpack_public_path__ + "static/media/bossa-patates-velles-3.b7339fc9.jpg";